import { render, staticRenderFns } from "./playtest.vue?vue&type=template&id=08658c34&"
import script from "./playtest.vue?vue&type=script&lang=js&"
export * from "./playtest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports